import { ChevronRight } from 'lucide-react';
import type { SimulationConversation } from '@/types/evaluator';
import { formatActionText, getTurnLabel, parseConversation } from '../utils';

export function ConversationTranscript({ conversation }: { conversation: SimulationConversation }) {
  const turns = parseConversation(conversation.output);

  if (turns.length === 0) {
    return (
      <div className="rounded-md border border-border/80 bg-muted/20 px-3 py-3 text-sm text-muted-foreground">
        No transcript is available for this conversation.
      </div>
    );
  }

  return (
    <div className="rounded-md border border-border/80 bg-background">
        {turns.map((turn, index) => {
          const isAction = turn.speaker === 'ToolCall';

          if (isAction) {
            return (
              <div
                key={`${turn.speaker}-${index}`}
                className="grid items-start gap-3 border-b border-border/70 px-3 py-2 last:border-b-0 sm:grid-cols-[72px_minmax(0,1fr)]"
              >
                <span className="inline-flex items-center gap-1 pt-0.5 text-[11px] font-medium text-muted-foreground">
                  <ChevronRight className="h-3.5 w-3.5" />
                  Action
                </span>
                <p className="min-w-0 truncate text-[13px] leading-5 text-muted-foreground">{formatActionText(turn.text)}</p>
              </div>
            );
          }

          return (
            <div
              key={`${turn.speaker}-${index}`}
              className="grid items-start gap-3 border-b border-border/70 px-3 py-3 transition-colors last:border-b-0 hover:bg-muted/20 sm:grid-cols-[72px_minmax(0,1fr)]"
            >
              <span className="pt-0.5 text-[11px] font-medium text-muted-foreground">{getTurnLabel(turn.speaker)}</span>
              <p className="max-w-[86ch] whitespace-pre-wrap text-[13px] leading-6 text-foreground">{turn.text}</p>
            </div>
          );
        })}
    </div>
  );
}
